import type { FC } from 'react';

import { readField } from '@eneco/cms-types';
import { Card, Heading, Stack, Text, TextLink } from '@eneco/sparky';
import { signIn } from 'next-auth/react';

/** A text inside Sitecore's `{ value }`, or as the CMS layer hands it over, without it. */
type TextOf = { value?: string } | string;

interface Props {
  /**
   * Sitecore's `login` section, or the same three fields from a step's flat content, where the step
   * maps its own names onto these (such as `login_title` and `login_text`).
   */
  textualData?: {
    loginLinkText?: TextOf;
    text?: TextOf;
    title?: TextOf;
  };
}

export const LoginCard: FC<Props> = ({ textualData }) => {
  if (!textualData) return null;

  return (
    <Stack.Item>
      <Card>
        <Card.Content>
          <Stack gap="6">
            <Heading size="XS" as="h2">
              {readField<string>(textualData.title)}
            </Heading>
            <Text size="BodyS" as="p">
              {readField<string>(textualData.text)}
            </Text>
            <TextLink emphasis="high" onClick={() => signIn('okta')}>
              Login
            </TextLink>
          </Stack>
        </Card.Content>
      </Card>
    </Stack.Item>
  );
};
